var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "md-button md-raised md-primary md-theme-default",
      attrs: {
        type: _vm.type ? _vm.type : "button",
        disabled: _vm.submitting || _vm.disabled ? "disabled" : null
      },
      on: {
        click: function($event) {
          _vm.onClick($event)
        }
      }
    },
    [
      _c("div", { staticClass: "md-ripple md-disabled" }, [
        _c("div", { staticClass: "md-button-content" }, [
          _vm._v("\n            " + _vm._s(_vm.label) + "\n        ")
        ])
      ]),
      _vm._v(" "),
      _c("md-progress-bar", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.submitting,
            expression: "submitting"
          }
        ],
        attrs: { "md-mode": "indeterminate" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67ac5b2c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67ac5b2c","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/SubmitButtonComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-67ac5b2c","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/SubmitButtonComponent.vue
// module chunks = 1 2 3